import { AssetType } from '@amzn/fire-tv-campaign-automation-service';
import shell11InchLandscape from 'public/images/tablet-shells/FireTabletsFeatureRotator_11Inch_Landscape_KH_Shell.png';
import {
  PreviewStateConfig,
  LayerType,
  BackgroundTransformType,
  LogoTransformType,
  GradientDirection,
} from 'src/utils/preview/types';

import {
  ALT_TEXT,
  SHIFT_FACTOR,
  GRADIENT_DARK,
  GRADIENT_TRANSPARENT,
  SCRIM_START,
  SCRIM_END,
  MAX_LINES,
  FONT_FAMILY,
  TEXT_COLOR,
} from '../constants';

export const TABLET_11INCH_LANDSCAPE_KH: PreviewStateConfig = {
  label: '11" Landscape KH',
  altText: ALT_TEXT,
  dimensions: { width: 1280, height: 800 },
  metadataZone: { top: 216, ctaTop: 516, safeZone: 70, leftMargin: 90 },
  layers: [
    {
      type: LayerType.BACKGROUND,
      transform: {
        type: BackgroundTransformType.CENTER_CROP,
        shiftFactor: SHIFT_FACTOR,
        x: 92,
        y: 216,
        width: 1096,
        height: 400,
      },
    },
    {
      type: LayerType.GRADIENT,
      direction: GradientDirection.HORIZONTAL,
      colorStops: [
        { position: 0, color: GRADIENT_DARK },
        { position: 1, color: GRADIENT_TRANSPARENT },
      ],
      bounds: { x: 92, y: 216, width: 700, height: 400 },
    },
    {
      type: LayerType.LOGO,
      transform: {
        type: LogoTransformType.FIT_WITHIN,
        maxWidth: 372,
        maxHeight: 150,
        position: { x: 149, y: 261 },
      },
    },
    {
      type: LayerType.TEXT,
      position: {
        x: 149,
        y: 435,
      },
      fontSize: 23,
      fontFamily: FONT_FAMILY,
      color: TEXT_COLOR,
      maxWidth: 400,
      maxLines: MAX_LINES,
      lineHeight: 30,
    },
    {
      type: LayerType.GRADIENT,
      direction: GradientDirection.VERTICAL,
      colorStops: [
        { position: 0, color: SCRIM_START },
        { position: 1, color: SCRIM_END },
      ],
      bounds: { x: 92, y: 216, width: 1096, height: 35 },
    },
    {
      type: LayerType.GRADIENT,
      direction: GradientDirection.VERTICAL,
      colorStops: [
        { position: 0, color: SCRIM_END },
        { position: 1, color: SCRIM_START },
      ],
      bounds: { x: 92, y: 546, width: 1096, height: 70 },
    },
    { type: LayerType.SHELL, src: shell11InchLandscape },
  ],
  assetRequirements: [AssetType.BACKGROUND_IMAGE, AssetType.LOGO],
};
